export class PluginRegistry {
    constructor() {
        this.entries = new Map;
    }
    install(plugin) {
        this.entries.set(plugin.name, plugin);
    }
    uninstall(name) {
        this.entries.delete(name);
    }
    get(name) {
        return this.entries.get(name);
    }
    getAll() {
        return Array.from(this.entries.values());
    }
    clear() {
        this.entries.clear();
    }
}
//# sourceMappingURL=plugin-registry.js.map
